import React, { useEffect } from "react";
import { getPostBySlug } from "../data/blogPosts";
import SEO from "./SEO";
import "./BlogPost.css";

const BlogPost = ({ t, language, slug }) => {
  const postSlug = slug || window.location.hash.replace("#blog/", "");
  const post = getPostBySlug(postSlug, language);

  if (!post) {
    return (
      <section className="section blog-post-section">
        <div className="blog-post-not-found">
          <h2>{t.blog.notFound}</h2>
          <a
            href="#blog"
            onClick={(e) => {
              e.preventDefault();
              window.location.hash = "blog";
              window.dispatchEvent(new HashChangeEvent("hashchange"));
            }}
          >
            {t.blog.backToBlog}
          </a>
        </div>
      </section>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (language === "fa") {
      return new Intl.DateTimeFormat("fa-IR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(date);
    }
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  return (
    <>
      <SEO
        language={language}
        title={`${post.title} - ${t.hero.name}`}
        description={post.excerpt}
        type="article"
      />
      <section className="section blog-post-section">
        <article className="blog-post">
          <a
            href="#blog"
            className="blog-back-btn"
            onClick={(e) => {
              e.preventDefault();
              window.location.hash = "blog";
              window.dispatchEvent(new HashChangeEvent("hashchange"));
            }}
          >
            {language === "fa" ? "← " : "← "}
            {t.blog.backToBlog}
          </a>
          <div className="blog-post-header">
            <div className="blog-post-meta">
              <span className="blog-post-category">{post.category}</span>
              <span className="blog-post-date">{formatDate(post.date)}</span>
            </div>
            <h1 className="blog-post-title">{post.title}</h1>
          </div>
          {post.image && (
            <div className="blog-post-image">
              <img src={process.env.PUBLIC_URL + post.image} alt={post.title} />
            </div>
          )}
          <div className="blog-post-content">
            <div
              className="blog-post-text"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </div>
          <div className="blog-post-footer">
            <div className="blog-post-tags">
              {post.tags.map((tag, index) => (
                <span key={index} className="blog-post-tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </article>
      </section>
    </>
  );
};

export default BlogPost;
